<template>
    <f7-page name="teammate"> 
       <bc-navbar></bc-navbar>
      <div class="page_maincontent layout_fullwidth_padding" v-if="isLoadedPage && teammate">
          <a v-on:click="back">
            <img src="/static/images/icons/black/back.png" alt="" class="back_image_button" title="" >
          </a>
           <p style="margin-bottom: 5px;">
               <strong style="font-size:20px;text-transform:uppercase;">
                   {{teammate.fullName}}
                </strong>
            </p>
           <span style="font-size:18px;text-transform:uppercase;">{{teammate.title}}</span>
           <img :src='teammate.photo' class="teammate-photo" />
           <div v-if="isButtonShowed && !customerUser.isDemoUser && teammate.isCustomerApp"  class="teammate-btn" :style="borderStyle" @click='registerCustomerApp(teammate.id)'>{{regButtonText}}</div>
           <div v-if="!isButtonShowed && !isDBCRegistered" style="text-align: center;">Registering...</div>
           <div v-if="!isButtonShowed && isDBCRegistered" class="link"  @click='goToDBC()'>Go to Digital Business Card</div>
           <div class='teammate-bio'>
               <strong style="font-size: 20px;">BIO</strong>
               <div class='teammate-bio-content' v-html="teammate.bio"></div>
           </div>
       </div>
        <div style="position: absolute; left: 50%;top:50%" v-if="!isLoadedPage">
              <div style="position: relative; left: -50%;"> 
                   <looping-rhombuses-spinner  :animation-duration="2500" :rhombus-size="25" :color="customization.mainColor" /> 
              </div>
        </div>                 
    </f7-page>
</template>
           
<script>
import { mapState, mapActions } from 'vuex'
import { LoopingRhombusesSpinner } from 'epic-spinners'

export default {
  name: 'teammate',
  components: {
    LoopingRhombusesSpinner
  },
  mounted: function () {
    this.isButtonShowed = true
    this.isDBCRegistered = false
    if (this.teammate.salesPersonId === 0) {
      this.loadTeamList().then(function () {
        this.loadSalesPerson(this.salesPersonId).then(function () {
          this.isLoadedPage = true
        }.bind(this))
      }.bind(this))
    } else {
      this.isLoadedPage = true
    }
  },
  computed: {
    ...mapState({
      teammate: state => state.meetTheTeam.teammate,
      customization: state => state.common.customization,
      customerUser: state => state.editUserProfile.customerUser
    }),
    borderStyle: function () {
      var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor : 'none'
      var backgroundStyle = this.customization.mainColor
      var colorStyle = this.customization.fontColor
      return {
        border: borderStyle,
        background: backgroundStyle,
        color: colorStyle
      }
    },
    regButtonText: function () {
      return 'Get ' + this.teammate.fullName + "'s Digital Business Card"
    }
  },
  methods: {
    ...mapActions('meetTheTeam', [
      'loadTeamList', 'loadSalesPerson', 'setCustomerToNewSalesPerson'
    ]),
    back () {
      this.$router.load({ url: 'meet-the-team' })
    },
    registerCustomerApp (id) {
      this.isButtonShowed = false
      this.setCustomerToNewSalesPerson(this.teammate.id).then(function (result) {
        this.salesUrl = result
        this.isDBCRegistered = true
      }.bind(this))
    },
    goToDBC () {
      var win = window.open(this.salesUrl)
      win.focus()
    }
  },
  data () {
    return {
      salesPersonId: this.$route.params.id,
      isLoadedPage: false,
      isDBCRegistered: false,
      isButtonShowed: true,
      salesUrl: ''
    }
  }
}
</script>
<style>
.teammate-photo{
    width: 100%;
    object-fit: cover;
}
.teammate-btn{
    margin: 12px 0px;
    background: #fff;
    border: none;
    text-align: center;
    padding: 10px;
    cursor: pointer;
}
.teammate-bio{
    padding-bottom: 25px;
}
.link{
    text-align: center;
    width: 100%;
    color: #2196f3;
    cursor: pointer;
}
</style>

       



// WEBPACK FOOTER //
// teammate.vue?95f0f5b2